<template>
  <NoteSection
    label="Labs"
  >
    <auto-complete-box
      v-model="labs"
      :items="labOptions"
      label="Choose Labs"
      class="col-sm-7"
      multiple
      return-object
      @input="$emit('input', labs)"
    ></auto-complete-box>
    <date-picker
      v-model="labs_order_date"
      :max="$date().format('YYYY-MM-DD')"
      label="Date Ordered"
      class="col-sm-5 align-self-start"
      clearable
      :required="labs.length > 0"
      @input="handleDateInput"
    ></date-picker>
    <text-area
      v-if="labs.some(x => x.title === 'Other')"
      v-model="labs_other"
      class="col-sm-12"
      label="Enter other labs..."
      required
      counter="7300"
      maxlength="7300"
      @input="$emit('update:labs-other', labs_other)"
    ></text-area>
  </NoteSection>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Array,
      default: null,
    },
    labsOther: {
      type: String,
      default: null,
    },
    labsOrderDate: {
      type: String,
      default: null,
    },
    encounterVisitDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      labs: [...this.value],
      labs_other: this.labsOther,
      labs_order_date: this.labsOrderDate,
      encounter_visit_date: this.encounterVisitDate,
    }
  },
  computed: {
    ...mapGetters('encounters', ['labOptions']),
  },
  watch: {
  },
  beforeDestroy() {
    // Remove the 'dateChange' event listener to prevent memory leaks
    this.$root.$off('dateChange', this.handleDateChange)
  },
  mounted() {
    // method from encounter details to update variable when date changes
    this.$root.$on('dateChange', this.handleDateChange)
  },
  methods: {
    handleDateChange(date) {
      this.encounter_visit_date = date
      if (this.labs_order_date) this.handleDateInput()
    },
    handleDateInput() {
      if (this.encounter_visit_date < this.labs_order_date) {
        this.$root.confirm({
          title: 'Notice: Date of Service',
          titleIconColor: 'warning',
          body: 'Labs order date cannot occur after the note date of service',
          cancel: false,
        })
        this.labs_order_date = undefined
      } else {
        this.$emit('update:labs-order-date', this.labs_order_date)
      }
    },
  },
}
</script>
